// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608111638/js/" + chunkId + "." + {"44":"853dc013","225":"9d001891","481":"22158102","486":"236f8e83","770":"16cb5de9"}[chunkId] + ".0.7386180975505261.chunk.js";
};